import { h, t as translate, d, D as DECATHLON_NAMESPACE, N as NON_FOLLOWED_TAG, T as Translate, I as IS_LOADING_CLASSNAME, e as DY_DECATHLON_NAMESPACE } from './built-constants-439d5572.js';
import { g as getFreeShippingThreshold, a as getFreeShippingThresholdDollars } from './built-config-a65ae98c.js';
import { v, c as clsx } from './built-clsx.m-cb13ff27.js';
import { f as formatPriceSingle } from './built-price-format-dc3d77ee.js';
import { i as isBulkyProduct, a as isNewReleaseProduct, b as isInnovationProduct } from './built-error-message-utilities-4ca13134.js';
import { o as onAddToCart } from './built-on-add-to-cart-59888dcc.js';
import { g as getProductTileData } from './built-make-request-bc649a18.js';
import { s as showElement } from './built-element-utils-09877efc.js';

/**
 * Handles UI state for the "availability"
 * @see https://app.gitbook.com/@decathlonusa/s/shopify/implemented-features-documentation/product-tiles-and-carousel#availability
 * @param {Object} props
 * @param {number} props.totalVariants
 * @param {number} props.availableVariants
 *
 * @todo: add out of stock logic (shouldn't come back from DY/display?)
 */
const Availability = ({
  totalVariants,
  availableVariants
}) => availableVariants / totalVariants < 0.5 ? h("p", {
  class: "de-u-textRed de-u-textMedium de-u-textShrink1 de-u-spaceBottomNone"
}, translate("Tallas limitadas")) : h(d, null);

var _window$DECATHLON_NAM;
const TILE_SUCCESS_MESSAGE_TIMEOUT = ((_window$DECATHLON_NAM = window[DECATHLON_NAMESPACE]) == null ? void 0 : _window$DECATHLON_NAM.productTileSuccessMessageTimeout) || 5000;
/**
 * @param {object} props
 * @param {ProductTile} props.productTile
 */

const CallToActionButton = ({
  productTile
}) => {
  const [addToCartStatus, setAddToCartStatus] = v(
  /** @type {ProductTileATCState['status']} */
  'idle');
  const [messageTimeoutId, setMessageTimeoutId] = v(null);
  const [addToCartErrorMessage, setAddToCartErrorMessage] = v('');
  const isSingleVariantProduct = productTile.variants.edges.length === 1;
  const isNonFollowedProduct = productTile.tags.includes(NON_FOLLOWED_TAG);
  /**
   * Submit form handler
   * Will add the product to cart and handle the component local ATC state.
   * @param {import('../../product-tile-atc').ProductTileAddToCartFormEvent} event
   */

  const onSubmitForm = event => {
    onAddToCart(event, {
      onPending: () => setAddToCartStatus('pending'),
      onSuccess: () => {
        setAddToCartStatus('success'); // Clear previous timeout before setting new one

        messageTimeoutId && clearTimeout(messageTimeoutId);
        setMessageTimeoutId(setTimeout(() => {
          setAddToCartStatus('idle');
        }, TILE_SUCCESS_MESSAGE_TIMEOUT));
      },
      onError: ({
        error
      }) => {
        setAddToCartStatus('error'); // Clear the timeout in this case as well to keep the error displayed

        messageTimeoutId && clearTimeout(messageTimeoutId);
        setAddToCartErrorMessage(error.message);
      }
    });
  };

  return h(d, null, h("p", {
    class: "de-u-spaceNone"
  }, h("span", {
    class: "de-u-hiddenVisually"
  }, productTile.title), h("span", {
    class: "de-ProductTileAddToCart-Message de-u-block de-u-textRed de-u-textMedium de-u-textShrink1"
  }, addToCartStatus === 'success' && translate("Añadir al carrito"), addToCartStatus === 'error' && addToCartErrorMessage)), isSingleVariantProduct && h("form", {
    // @todo Figure out why there is a type mismatch for the onSubmit
    // @ts-ignore
    onSubmit: onSubmitForm,
    method: "post",
    action: "/cart/add",
    "data-is-non-followed": isNonFollowedProduct ? 'true' : 'false'
  }, h("input", {
    type: "hidden",
    name: "id",
    value: productTile.colorSwatches[0].id
  }), h("input", {
    type: "hidden",
    name: "quantity",
    value: "1"
  }), h("input", {
    type: "hidden",
    name: "variantId",
    value: productTile.colorSwatches[0].id
  }), h("button", {
    type: "submit",
    "aria-live": "assertive",
    class: "btn btn--fill btn--full de-Button de-u-pad06 de-u-spaceBottom1 de-u-md-spaceBottomNone",
    disabled: addToCartStatus === 'pending' || addToCartStatus === 'error'
  }, (addToCartStatus === 'idle' || addToCartStatus === 'success' || addToCartStatus === 'error') && translate("Agregar al carrito"), addToCartStatus === 'pending' && translate("Agregando..."))), !isSingleVariantProduct && h("a", {
    class: "btn btn--full de-u-pad06 de-u-spaceBottom1 de-u-md-spaceBottomNone",
    href: "/products/" + productTile.handle
  }, translate("Ver opciones")));
};

/**
 * @param {Object} props
 * @param {boolean} props.isBulky
 * @param {Array<number|null>} props.prices
 * @param {number} [props.freeShippingThresholdCents] The free shipping threshold in cents (e.g. one dollar = '100')
 * @param {number} [props.freeShippingThresholdDollars] The free shipping threshold in dollars (e.g. one dollar = '1')
 */
const FulfillmentOptions = ({
  isBulky,
  prices,
  freeShippingThresholdCents = getFreeShippingThreshold(),
  freeShippingThresholdDollars = getFreeShippingThresholdDollars()
}) => {
  const minPrice = Math.min(...prices);
  const isFreeThresholdMet = minPrice >= freeShippingThresholdCents;
  return h(d, null, h("p", {
    class: "de-u-spaceNone de-u-textShrink1 de-u-textMedium"
  }, isBulky ? translate("Ver costo de envió en checkout") : isFreeThresholdMet ? h(Translate, {
    expression: "Envio gratis",
    price: freeShippingThresholdDollars
  }) : h(Translate, {
    expression: "Envio gratis con pedidos mayores a ${{ price }}",
    price: freeShippingThresholdDollars
  })), h("p", {
    class: "de-u-textShrink1 de-u-textMedium"
  }, translate("Recogida gratuita")));
};

/**
 * Helper to determine if prices vary
 * @param {number|null} price
 * @param {number} _index
 * @param {(number|null)[]} prices
 */
const pricesVary = (price, _index, prices) => prices[0] !== price;
/**
 * Handles price UI state
 * @see https://app.gitbook.com/@decathlonusa/s/shopify/implemented-features-documentation/product-tiles-and-carousel#range-of-prices
 * @param {Object} props
 * @param {(number)[]} props.prices
 * @param {(number|null)[]} [props.compareAtPrices=[]]
 */


const Price = ({
  prices,
  compareAtPrices = []
}) => {
  const priceVaries = prices.some(pricesVary);
  const compareAtPriceVaries = compareAtPrices.some(pricesVary);
  const shouldCurrentPriceBeRanged = priceVaries || compareAtPriceVaries;
  const shouldRenderCompareAtPrice = !shouldCurrentPriceBeRanged && compareAtPrices.length > 0;
  const currentFormattedPrice = shouldCurrentPriceBeRanged ? formatPriceSingle(Math.min(...prices, ...compareAtPrices)) + " - " + formatPriceSingle(Math.max(...prices, ...compareAtPrices)) : formatPriceSingle(prices[0]);
  /**
   * @todo The following data is missing in the UI template:
   * - priceCurrency: `cart.currency.iso_code`
   * - `product.url`
   * - `product.available`
   */

  return h("div", {
    itemProp: "offers",
    itemScope: true,
    itemType: "https://schema.org/Offer",
    "aria-live": "polite",
    "aria-atomic": "true"
  }, h("meta", {
    itemProp: "priceCurrency",
    content: "{{ cart.currency.iso_code }}"
  }), h("link", {
    itemProp: "url",
    href: "{{ shop.url }}{{ product.url }}"
  }), h("link", {
    itemProp: "availability" // @todo Make sure this works
    ,
    href: "https://schema.org/OutOfStock"
  }), h("p", {
    class: "de-ProductTile-price de-u-md-textGrow2 de-u-textMedium de-u-lineHeight4 de-u-spaceBottomNone"
  }, h("meta", {
    itemProp: "price" // @todo Make sure this works
    ,
    content: "{{ available_product_price_min | money_without_currency | remove : settings.remove_from_price }}"
  }), h("span", {
    class: "de-u-hiddenVisually"
  }, shouldRenderCompareAtPrice ? translate("Precio de oferta") : translate("Precio habitual")), currentFormattedPrice, shouldRenderCompareAtPrice && h("del", {
    class: "de-u-padLeft02 de-u-textShrink2"
  }, h("span", {
    class: "de-u-hiddenVisually"
  }, translate("Precio habitual")), h("span", null, formatPriceSingle(compareAtPrices[0])))));
};

const LastCallFlag = () => h("span", {
  class: "de-ProductFlag de-u-textMedium de-u-bgRed de-u-textWhite"
}, h("span", {
  class: "de-u-hiddenVisually"
}, translate("Producto especial") + ", "), translate("Ultimo llamado"));

const InnovationFlag = () => h("span", {
  class: "de-ProductFlag de-u-textMedium de-u-bgLime de-u-textBlack"
}, h("span", {
  class: "de-u-hiddenVisually"
}, translate("Producto especial") + ", "), translate("innovación"));

const NewReleaseFlag = () => h("span", {
  class: "de-ProductFlag de-u-textMedium de-u-bgBlue de-u-textWhite"
}, h("span", {
  class: "de-u-hiddenVisually"
}, translate("Producto especial") + ", "), translate("Nuevos productos"));

const CustomFlag = ({
  classes,
  content
}) => h("span", {
  class: clsx('de-ProductFlag de-u-textMedium', classes)
}, h("span", {
  class: "de-u-hiddenVisually"
}, translate("Producto especial") + ", "), content);
/**
 *
 * @param {Object} props
 * @param {boolean} props.isInnovationProduct
 * @param {boolean} props.isLastCall
 * @param {boolean} props.isNewReleaseProduct
 * @param {string} [props.customContent]
 * @param {string} [props.customContentClasses]
 */


const ProductFlags = ({
  isInnovationProduct,
  isNewReleaseProduct,
  isLastCall,
  customContent,
  customContentClasses = 'de-u-textShrink2 de-u-md-Grow1'
}) => {
  let flagToShow = h(d, null);

  if (customContent) {
    flagToShow = h(CustomFlag, {
      content: customContent,
      classes: customContentClasses
    });
  } else if (isLastCall) {
    flagToShow = h(LastCallFlag, null);
  } else if (isInnovationProduct) {
    flagToShow = h(InnovationFlag, null);
  } else if (isNewReleaseProduct) {
    flagToShow = h(NewReleaseFlag, null);
  }

  return flagToShow;
};

// @ts-check
/**
 *
 * @param {Object} props
 * @param {string} [props.alt]
 * @param {string} [props.title]
 * @param {string} [props.colorName]
 * @param {string} props.image
 *
 * @todo: secondary image on hover
 */

const ProductImage = ({
  alt,
  title,
  colorName = '',
  image = '' // @todo Figure out if this is needed or how this is used
  // showSecondaryImage = false

}) => {
  return h("div", {
    class: "de-productTile-showcaseImageContainer"
  }, h("img", {
    alt: alt || title + " " + colorName,
    class: "de-ProductTile-showcaseImage",
    itemProp: "image",
    src: image // @todo Update Preact dependency so `loading` attribute doesn't cause type error
    // @see https://github.com/preactjs/preact/releases/tag/10.4.2
    // @ts-ignore
    ,
    loading: "lazy"
  }));
};

// @ts-check
/**
 *
 * @param {Object} props
 * @param {ProductTileColorSwatch} props.colorSwatch
 * @param {string} props.url
 * @param {import('preact/hooks').StateUpdater<ProductTileColorSwatch>} props.setCurrentColorSwatch
 */

const ColorSwatch = ({
  colorSwatch,
  url,
  setCurrentColorSwatch
}) => {
  // Helper to select the current color swatch
  const selectColorSwatch = () => setCurrentColorSwatch(colorSwatch);

  return h("a", {
    class: "de-SwatchObjects-item de-ColorSwatches-color",
    itemProp: "color",
    href: url + "?variant=" + colorSwatch.id,
    onMouseEnter: selectColorSwatch,
    onFocusCapture: selectColorSwatch // @todo Can we use anything other than a test ID?
    ,
    "data-testid": colorSwatch.color
  }, h("img", {
    class: "de-SwatchObject-image de-u-block",
    src: colorSwatch.image,
    alt: colorSwatch.imageAlt // @todo Update Preact dependency so `loading` attribute doesn't cause type error
    // @see https://github.com/preactjs/preact/releases/tag/10.4.2
    // @ts-ignore
    ,
    loading: "lazy"
  }));
};

// There is a limit of color swatches to render per designs.
const MAX_COLOR_SWATCHES_TO_RENDER = 3;
/**
 *
 * @param {Object} props
 * @param {ProductTileColorSwatch[]} props.colorSwatches
 * @param {string} props.productPathname E.g. '/products/mens-trek-100-hooded-jacket'
 * @param {import('preact/hooks').StateUpdater<ProductTileColorSwatch>} props.setCurrentColorSwatch
 * @param {boolean} props.renderColorSwatches
 */

const ColorSwatches = ({
  colorSwatches,
  productPathname,
  setCurrentColorSwatch,
  renderColorSwatches
}) => {
  // We want to limit the amount of color swatches rendered, save a limited array copy.
  // @todo Consider using `useCallback()` hook for memoization
  const colorSwatchesToRender = [...colorSwatches].slice(0, MAX_COLOR_SWATCHES_TO_RENDER);
  const extraColorSwatchTotal = colorSwatches.length - MAX_COLOR_SWATCHES_TO_RENDER; // If there are more than MAX_COLOR_SWATCHES_TO_RENDER, add a "plus" link (e.g. +4)

  const renderPlusLink = renderColorSwatches && extraColorSwatchTotal > 0;
  const renderVisuallyHiddenCopy = renderColorSwatches && colorSwatches.length > 0;
  return h("div", {
    class: "de-SwatchObjects de-SwatchObjects--productTile de-u-padEnds06"
  }, renderVisuallyHiddenCopy && h("p", {
    class: "de-u-hiddenVisually"
  }, translate("Colores disponibles")), renderColorSwatches && colorSwatchesToRender.map(colorSwatch => h(ColorSwatch, {
    colorSwatch: colorSwatch,
    url: productPathname,
    setCurrentColorSwatch: setCurrentColorSwatch
  })), renderPlusLink && h("a", {
    class: "de-SwatchObjects-item de-ColorSwatches-color de-u-textDarkGray",
    href: productPathname
  }, h("span", {
    "aria-hidden": "true"
  }, "+", extraColorSwatchTotal), h("span", {
    class: "de-u-hiddenVisually"
  }, extraColorSwatchTotal + " " + translate({"one" : "Otro color disponible", "other" : "Mas colores disponibles"}, {
    count: extraColorSwatchTotal
  }))));
};

const DecathlonLogo = ({
  class: classes
}) => h("svg", {
  viewBox: "0 0 109.42541 24",
  width: "109.42541",
  height: "24",
  role: "img",
  class: classes
}, h("title", null, "Decathlon"), h("path", {
  d: "M42.18,3.855l-6.09,10.28a4.89,4.89,0,0,1-3.77,2.15,4.46,4.46,0,0,1-4.45009-4.46989L27.87,11.795a4.38,4.38,0,0,1,4.35-4.3,5.52,5.52,0,0,1,3.58,1.59,5.13032,5.13032,0,0,1,1.06,1.12l2.23-3.74A6.85042,6.85042,0,0,0,38,5.535a9,9,0,0,0-5.71-2.06,8.55,8.55,0,0,0-7,3.37,7.64,7.64,0,0,0-1.74,5,8.35,8.35,0,0,0,2.22,5.71,9.39,9.39,0,0,0,6.38,2.8,9.46,9.46,0,0,0,5-1.5,9.18,9.18,0,0,0,1.55-1.26h3.87v2.34h4V3.855Zm.39,10.37H40.44l2.13-3.64Z"
}), h("polygon", {
  points: "50.44 20.025 50.44 7.655 47.31 7.655 47.31 3.915 57.77 3.915 57.77 7.655 54.57 7.655 54.57 20.025 50.44 20.025 50.44 20.025"
}), h("polygon", {
  points: "66.86 13.865 62.63 13.865 62.63 20.025 58.5 20.025 58.5 3.915 62.63 3.915 62.63 10.035 66.86 10.035 66.86 3.915 71.01 3.915 71.01 20.025 66.86 20.025 66.86 13.865 66.86 13.865"
}), h("path", {
  d: "M105.28,3.915v9l-6.19-9H95.37v5.44a8.3201,8.3201,0,0,0-2.2-3.35,9,9,0,0,0-12.17,0,7.89,7.89,0,0,0-2.57,5.83,8.32,8.32,0,0,0,1.33,4.66H76.6V3.915H72.5v16.11h8.92v-1.7a8.62,8.62,0,0,0,5.7,2,8.78,8.78,0,0,0,6.22-2.52,8.12008,8.12008,0,0,0,2-3.27v5.49h4.12v-9l6.29,9h3.64V3.915ZM87.12,16.335a4.51,4.51,0,0,1-4.44-4.49,4.42,4.42,0,1,1,4.44,4.49Z"
}), h("path", {
  d: "M23.62,7.405V3.855H14.43v6.62a7.5,7.5,0,0,0-2.35-4.63c-1.75-1.59-3.63-1.93-6.31-1.93H0v16.11H6.34c2.37,0,4-.32,5.77-2a7.62,7.62,0,0,0,2.32-4.5v6.4h9.19v-3.45H18.49v-3h4.45v-3.45H18.49V7.405ZM5.79,16.495H4.13V7.385H5.77c3,0,4.67,1.63,4.67,4.53C10.44,15.085,8.95,16.495,5.79,16.495Z"
}));

/**
 * Renders the following:
 * - star ratings
 * - total review count
 *
 * @param {object} props
 * @param {number | null} props.ratingValue E.g. 4.5
 * @param {number | null} props.totalReviewCount
 */
const StarRatingsAndReviewCount = ({
  ratingValue,
  totalReviewCount
}) => {
  const ratingPercent = ratingValue / 5 * 100;
  const starFillStyle = "width: " + ratingPercent + "%"; // Handles null values, allows for rendering "0" to UI

  const reviewCount = totalReviewCount || 0; // Prevents a "0" from rendering to the screen
  // @see DEC-5804

  const renderVisuallyHiddenRating = ratingValue !== null;
  return h("div", {
    class: "de-u-flex de-u-flexAlignItemsCenter de-u-spaceTop06 de-u-lineHeight1"
  }, h("span", {
    class: "de-StarRating de-u-spaceRight06 de-StarRating--small"
  }, h("span", {
    class: "de-StarRating-fill",
    style: starFillStyle,
    "aria-hidden": "true"
  }), renderVisuallyHiddenRating && h("span", {
    class: "de-u-hiddenVisually"
  }, h(Translate, {
    expression: "Reseña promedio: {{ratingValue}} de 5 estrellas",
    ratingValue: ratingValue
  }))), h("span", {
    class: "de-u-textMedium de-u-textSelectNone de-u-textDarkGray de-u-textShrink2 de-u-md-textShrink1",
    "aria-hidden": "true"
  }, reviewCount), h("span", {
    class: "de-u-hiddenVisually"
  }, reviewCount + " " + translate("Reseñas")));
};

// @ts-check
/**
 * Renders the following:
 * - color swatches
 * - Decathlon brand logo
 * - product title
 * - product ratings
 *
 * @todo Render dynamic brand logos
 *
 * @param {object} props
 * @param {string} props.productPathname E.g. '/products/surface-snorkeling-easybreath-mask-500'
 * @param {ProductTileColorSwatch[]} props.colorSwatches
 * @param {string} props.title
 * @param {number | null} props.ratingValue E.g. 4.5
 * @param {number | null} props.totalReviewCount
 * @param {import('preact/hooks').StateUpdater<ProductTileColorSwatch>} props.setCurrentColorSwatch
 * @param {boolean} [props.renderColorSwatches=true]
 * @param {boolean} [props.renderBrandLogos=true]
 * @param {boolean} [props.renderRatings=true]
 */

const ProductTileInfo = ({
  productPathname,
  colorSwatches,
  title,
  ratingValue,
  totalReviewCount,
  setCurrentColorSwatch,
  renderBrandLogos = true,
  renderColorSwatches = true,
  renderRatings = true
}) => h("section", {
  class: "de-ProductTile-info"
}, h(ColorSwatches, {
  colorSwatches: colorSwatches,
  productPathname: productPathname,
  setCurrentColorSwatch: setCurrentColorSwatch,
  renderColorSwatches: renderColorSwatches
}), h("a", {
  class: "de-u-linkClean",
  href: productPathname
}, h("header", {
  class: "de-ProductTile-header"
}, renderBrandLogos && h(DecathlonLogo, {
  class: "de-u-spaceTop04 de-subBrandLogo"
}), h("h4", {
  class: "de-ProductTile-title de-ProductTile-titleWithButtons  de-u-textMedium de-u-textShrink1 de-u-lg-textGrow1 de-u-lineHeight2 de-u-spaceTop04",
  itemProp: "name"
}, title)), renderRatings && h(StarRatingsAndReviewCount, {
  ratingValue: ratingValue,
  totalReviewCount: totalReviewCount
})));

// @ts-check
/**
 * Default render options
 * @type {ProductTileRenderOptions}
 */

const RENDER_OPTION_DEFAULTS = {
  renderBrandLogos: true,
  renderFulfillmentOptions: true,
  renderProductFlags: true,
  renderRatings: true,
  renderColorSwatches: true,
  renderInventoryStatus: true
};
/**
 * @todo Complete/check this logic
 * @param {ProductTileColorSwatch} colorSwatch
 * @returns {boolean}
 */

const isLastCall = colorSwatch => colorSwatch.compareAtPrices.some(price => price !== null);
/**
 * @param {object} props
 * @param {ProductTile} props.productTile
 * @param {ProductTileRenderOptions} [props.renderOpts={}]
 * @param {string} [props.productTileClass='']
 */


const ProductTile = ({
  productTile,
  renderOpts = {},
  productTileClass = ''
}) => {
  var _productTile$dyTracki, _productTile$dyTracki2;

  /** @type {ProductTileRenderOptions} */
  const {
    renderColorSwatches,
    renderProductFlags,
    renderBrandLogos,
    renderRatings,
    renderFulfillmentOptions,
    renderInventoryStatus,
    renderCallToActionButton
  } = Object.assign({}, RENDER_OPTION_DEFAULTS, renderOpts); // Keeps track of the color swatch selected when hovering over them

  const [currentColorSwatch, setCurrentColorSwatch] = v(productTile.defaultColorSwatch); // We don't always want to render the color swatches

  const showColorSwatches = renderColorSwatches && productTile.colorSwatches.length > 1; // Helper to set the default color swatch as the current color swatch

  const setDefaultColorSwatch = () => setCurrentColorSwatch(productTile.defaultColorSwatch);

  return h("article", {
    class: clsx('de-ProductTile de-u-lineHeight3 de-u-bgWhite de-Skeleton js-de-Skeleton', productTileClass) // @todo Complete schema setup
    // itemProp="itemListElement"
    // itemScope
    // itemType="https://schema.org/Product"
    ,
    onMouseLeave: setDefaultColorSwatch,
    onBlurCapture: setDefaultColorSwatch // Dynamic Yield tracking data
    // @see https://support.dynamicyield.com/hc/en-us/articles/360022557954-Recommendations-Client-Side-APIs?flash_digest=9d5d53e6eb9dafa553e4645f42741999ba126f03#track-recommendation-widget-0-5
    ,
    "data-dy-product-id": (_productTile$dyTracki = productTile.dyTracking) == null ? void 0 : _productTile$dyTracki.productSku,
    "data-dy-strategy-id": (_productTile$dyTracki2 = productTile.dyTracking) == null ? void 0 : _productTile$dyTracki2.strategyId // @todo Can we use anything other than a test ID? This is used for integration tests.
    ,
    "data-testid": "product-tile"
  }, h("a", {
    class: "de-u-block",
    href: "/products/" + productTile.handle
  }, h("section", {
    class: clsx('de-ProductTile-showcase', !renderProductFlags && 'de-u-padTopNone')
  }, renderProductFlags && h(ProductFlags // @todo Make sure flags logic matches Gitbook requirements
  , Object.assign({}, productTile.flags, {
    isLastCall: isLastCall(currentColorSwatch)
  })), h(ProductImage, {
    title: productTile.title,
    alt: currentColorSwatch.imageAlt,
    colorName: currentColorSwatch.color,
    image: currentColorSwatch.image
  }))), h(ProductTileInfo, {
    productPathname: "/products/" + productTile.handle,
    colorSwatches: productTile.colorSwatches,
    title: productTile.title,
    ratingValue: productTile.ratingValue,
    totalReviewCount: productTile.totalReviewCount,
    setCurrentColorSwatch: setCurrentColorSwatch,
    renderBrandLogos: renderBrandLogos,
    renderColorSwatches: showColorSwatches,
    renderRatings: renderRatings
  }), h(Price, {
    prices: currentColorSwatch.prices,
    compareAtPrices: currentColorSwatch.compareAtPrices
  }), h("footer", {
    class: clsx('de-ProductTile-footer', !renderFulfillmentOptions && 'de-ProductTile-footer--reducedContent')
  }, renderInventoryStatus && h(Availability, {
    totalVariants: currentColorSwatch.totalVariants,
    availableVariants: currentColorSwatch.availableVariants
  }), renderFulfillmentOptions && h(FulfillmentOptions, {
    isBulky: productTile.isBulky,
    prices: currentColorSwatch.prices
  })), renderCallToActionButton && h(CallToActionButton, {
    productTile: productTile
  }));
};

/**
 * Helper to generate the render options for a product tile
 * @param {HTMLElement} el
 * @returns {ProductTileRenderOptions}
 */
const getProductTileRenderOptions = el => Object.entries(el.dataset).reduce((acc, attrTuple) => {
  // Destructure the attribute tuple
  const [attribute, value] = attrTuple;

  if (attribute.startsWith('render')) {
    acc[attribute] = value === 'true';
  }

  return acc;
}, {});

// @ts-check
/**
 * Remaps the product data for the Product Tile UI
 *
 * This logic was borrowed from a proof-of-concept
 * @see https://github.com/decathlon-usa/shopify-theme-decathlonusa/pull/1387
 * @todo Refactor code further if needed
 *
 * @param {object} props
 * @param {GQLProduct} props.product
 * @param {Slot[]} props.slots
 * @returns {ProductTile}
 */

const remapProductForProductTile = ({
  product,
  slots
}) => {
  // Get clone of product with base data
  const productTile = getProductTileBase({
    product,
    slots
  });
  /** @param {GQLSelectedOption} option */

  const colorOption = option => option.name === 'Color';
  /** @param {string} price */


  const priceToCents = price => Math.round(Number.parseFloat(price) * 100);

  for (const {
    node: variant
  } of productTile.variants.edges) {
    var _variant$selectedOpti;

    const variantColor = (_variant$selectedOpti = variant.selectedOptions.find(colorOption)) == null ? void 0 : _variant$selectedOpti.value;
    const colorSwatchIndex = productTile.colorSwatches.findIndex(colorSwatch => colorSwatch.color === variantColor);

    const isValidCompareAtPrice = price => price !== null && price > 0; // Color doesn't exist


    if (colorSwatchIndex === -1) {
      if (variant.isAvailable) {
        var _variant$image, _variant$image2, _variant$image3, _variant$image4, _variant$compareAtPri;

        productTile.colorSwatches.push({
          id: variant.id,
          color: variantColor,
          // The `variant.image` value can be `null`
          image: ((_variant$image = variant.image) == null ? void 0 : _variant$image.originalSrc) || '',
          imageAlt: ((_variant$image2 = variant.image) == null ? void 0 : _variant$image2.altText) || '',
          // @todo Where do we get image 2 from?
          image2: ((_variant$image3 = variant.image) == null ? void 0 : _variant$image3.originalSrc) || '',
          image2Alt: ((_variant$image4 = variant.image) == null ? void 0 : _variant$image4.altText) || '',
          prices: [priceToCents(variant.price.amount)],
          // We don't want null or 0 values for the compare at price
          compareAtPrices: isValidCompareAtPrice(Number.parseFloat((_variant$compareAtPri = variant.compareAtPrice) == null ? void 0 : _variant$compareAtPri.amount)) ? [priceToCents(variant.compareAtPrice.amount)] : [],
          availableVariants: 1,
          totalVariants: 1
        });
      }
    } else {
      // Color already exists
      const colorSwatch = productTile.colorSwatches[colorSwatchIndex];

      if (variant.isAvailable) {
        var _variant$compareAtPri2;

        colorSwatch.prices.push(priceToCents(variant.price.amount)); // We don't want null or 0 values for the compare at price

        isValidCompareAtPrice(Number.parseFloat((_variant$compareAtPri2 = variant.compareAtPrice) == null ? void 0 : _variant$compareAtPri2.amount)) && colorSwatch.compareAtPrices.push(priceToCents(variant.compareAtPrice.amount));
        colorSwatch.availableVariants += 1;
      }

      colorSwatch.totalVariants += 1;
    } // Update the defaults


    if (variant.isAvailable) {
      var _variant$compareAtPri3;

      productTile.defaultColorSwatch.availableVariants += 1;
      productTile.defaultColorSwatch.prices.push(priceToCents(variant.price.amount)); // We don't want null or 0 values for the compare at price

      isValidCompareAtPrice(Number.parseFloat((_variant$compareAtPri3 = variant.compareAtPrice) == null ? void 0 : _variant$compareAtPri3.amount)) && productTile.defaultColorSwatch.compareAtPrices.push(priceToCents(variant.compareAtPrice.amount));
    }

    productTile.defaultColorSwatch.totalVariants += 1;
  } // Product level data


  productTile.defaultColorSwatch.color = productTile.colorSwatches[0].color;
  return productTile;
};
/**
 * Retrieves the product or variant ID from the base-64 encoded value
 *
 * The Shopify Storefront API returns base-64 encoded ID values for products and
 * variants. This function helps retrieve the non-base-64 encoded ID value.
 * Note: Sometimes, the Storefront API does not return base-64 encoded IDs.
 * @see DEC-5801
 *
 * @param {string} gid A Shopify global ID
 */

const getIdFromGid = gid => {
  try {
    // Assumes the ID from Shopify is base-64 encoded.
    return window.atob(gid).replace(/[^\d]*/, '');
  } catch (error) {

    return gid;
  }
};
/**
 * Sanitizes the product data, creates a baseline to start with
 * @param {object} props
 * @param {GQLProduct} props.product
 * @param {Slot[]} props.slots
 * @returns {ProductTile}
 */


const getProductTileBase = ({
  product,
  slots
}) => {
  var _product$featuredImag;

  /** @type ProductTile */
  const productTile = Object.assign({}, product, {
    id: getIdFromGid(product.id),
    isBulky: isBulkyProduct(product),
    flags: {
      isNewReleaseProduct: isNewReleaseProduct(product),
      isInnovationProduct: isInnovationProduct(product)
    },
    // Product Tile UI defaults
    defaultColorSwatch: {
      id: null,
      color: null,
      // In testing, some products had no images
      image: ((_product$featuredImag = product.featuredImage.edges[0]) == null ? void 0 : _product$featuredImag.node.originalSrc) || '',
      imageAlt: null,
      image2: null,
      image2Alt: null,
      prices: [],
      compareAtPrices: [],
      availableVariants: 0,
      totalVariants: 0
    },
    colorSwatches: [],
    variants: {
      edges: product.variants.edges.map(variant => ({
        node: Object.assign({}, variant.node, {
          id: getIdFromGid(variant.node.id)
        })
      }))
    }
  }, getRatingsAndReviews(product), {
    dyTracking: getDyTrackingForSlot(slots.find(slot => slot.item.group_id === getIdFromGid(product.id)))
  });
  return productTile;
};
/**
 * @typedef RatingsAndReviews
 * @property {ProductTile['ratingValue']} ratingValue
 * @property {ProductTile['totalReviewCount']} totalReviewCount
 */

/**
 * @param {GQLProduct} product
 * @returns {RatingsAndReviews}
 */


const getRatingsAndReviews = product => {
  const openVoiceReviewsCount = product.reviews && JSON.parse(product.reviews.value).total_item_count || 0;
  const openVoiceRatingValue = product.ratings && Number.parseFloat(product.ratings.value) || 0;
  const manualReviewsCount = product.manualReviews && JSON.parse(product.manualReviews.value).total_item_count || 0;
  let manualRatingValue = product.manualRatings && Number.parseFloat(product.manualRatings.value) || 0;

  if (manualReviewsCount >= openVoiceReviewsCount) {
    // No need to show a rating value (in case it exists) when there are 0 reviews
    if (manualReviewsCount === 0) {
      manualRatingValue = 0;
    }

    return {
      ratingValue: manualRatingValue,
      totalReviewCount: manualReviewsCount
    };
  }

  return {
    ratingValue: openVoiceRatingValue,
    totalReviewCount: openVoiceReviewsCount
  };
};
/**
 * @param {Slot} slot A DY slot respresents a product
 * @returns {ProductTile['dyTracking']} DY tracking data needed for a specific product tile
 */


const getDyTrackingForSlot = slot => ({
  productSku: (slot == null ? void 0 : slot.item.sku.toString()) || '',
  strategyId: (slot == null ? void 0 : slot.strId.toString()) || ''
});

// @ts-check
/**
 * Intializes the custom DY recommendations widgets
 * @param {object} props
 * @param {string} props.containerElSelector CSS selector for the container element
 * @param {string} props.targetElSelector CSS selector for target render element
 * @param {
    (data: {
      productTiles: ProductTile[], 
      renderOpts: ProductTileRenderOptions, 
      containerEl: HTMLElement, 
      targetEl: HTMLElement,
      dyWidgetTracking: DynamicYieldWidgetTracking,
      widgetTitle: string
    }) => void
  } props.onDataReady Function called when Shopify product data is available
 */

const initDyRecommendations = ({
  containerElSelector,
  targetElSelector,
  onDataReady
}) => {
  document.querySelectorAll(containerElSelector).forEach(
  /** @param {HTMLElement} containerEl */
  containerEl => {
    var _window$DYO;

    /**
     * Allows the DY-driven product tile carousel to only take up space when JS is
     * enabled and DY scripts are available.
     * Allows the skeleton loading UX to only activate when JS is enabled and DY
     * scripts are available.
     * Avoids having the skeleton loading UX getting "stuck" when JS is disabled
     * or the DY script fails.
     */
    containerEl.querySelectorAll('.js-de-Skeleton').forEach(skeletonEl => {
      skeletonEl.classList.add(IS_LOADING_CLASSNAME);
    });
    showElement(containerEl); // The target element that will be replaced by the DY-driven carousel

    /** @type {HTMLElement | null} */

    const targetEl = containerEl.querySelector(targetElSelector);

    if (!targetEl) {
      abandonInit({
        containerEl,
        error: new Error("Target selector \"" + targetElSelector + "\" not found within parent \"" + containerElSelector + " parent continaer.")
      });
    }

    const dyDecathlonNamespace = window[DY_DECATHLON_NAMESPACE];

    if (!dyDecathlonNamespace) {
      abandonInit({
        containerEl,

        /**
         * If the Dynamic Yield variation control is served, there will be no
         * `window.DY_DECATHLON` object. This is by design from DY's perspective
         * so it technically might not be an error. Throwing a JS error causes
         * confusion in this case, especially for reporting in TrackJS.
         * @todo Figure out way to not have this be an error, and instead, a warning?
         */
        error: new Error("The `window." + DY_DECATHLON_NAMESPACE + "` object does not exist. Check Dynamic Yield custom code campaign configuration.")
      });
    }

    const containerElSelectorData = dyDecathlonNamespace[containerElSelector];

    if (!containerElSelectorData) {
      abandonInit({
        containerEl,
        error: new Error("Missing selector '" + containerElSelector + "' on `window." + DY_DECATHLON_NAMESPACE + "` object. Check Dynamic Yield custom code campaign configuration.")
      });
    } // The Dynamic Yield widget (strategy) ID to fetch DY data


    const dyWidgetId = containerElSelectorData.widgetId; // Widget title from Dynamic Yield custom code campaign

    const widgetTitle = containerElSelectorData.widgetTitle;

    if (!dyWidgetId || dyWidgetId.trim() === '') {
      abandonInit({
        containerEl,
        error: new Error('Missing Dynamic Yield widget ID.')
      });
    } // We can't DY if there's no DY :)


    if (!((_window$DYO = window.DYO) == null ? void 0 : _window$DYO.recommendationWidgetData)) {
      abandonInit({
        containerEl,
        error: new Error('Dynamic Yield DYO object or recommendationWidgetData function undefined.')
      });
    } // If we've made it this far, we are cleared to initialize the DY carousels!


    window.DYO.recommendationWidgetData(dyWidgetId, {}, (error, dyData) => {
      if (error) {
        abandonInit({
          containerEl,
          error
        });
      }

      retrieveProductDataFromShopify(dyData.slots).then(productTiles => {
        if ((productTiles == null ? void 0 : productTiles.length) === 0) {
          abandonInit({
            containerEl,
            error: new Error('No product tiles returned from Shopify API')
          });
        } // Using a callback allows the caller (parent) to perform whatever action
        // we want when the data is ready. (e.g. Render a Preact component)


        onDataReady({
          productTiles: reorderProductTiles(dyData.slots, productTiles),
          renderOpts: getProductTileRenderOptions(containerEl),
          containerEl,
          targetEl,
          dyWidgetTracking: getDyWidgetTracking(dyData),
          widgetTitle
        });
      }).catch(error2 => {
        // If the Shopify fetch for data fails, remove loading element
        // @todo Since we have an error, we can rethrow the error.
        abandonInit({
          containerEl,
          error: error2
        });
      });
    });
  });
};
/**
 * Remaps the Shopify product tile order to match the original DY slot order
 * @param {Slot[]} dySlots
 * @param {ProductTile[]} shopifyProductTiles
 */

const reorderProductTiles = (dySlots, shopifyProductTiles) => dySlots.map(dySlot => shopifyProductTiles.find(productTile => productTile.id === dySlot.item.sku)) // Filter out undefined results
.filter(product => product);
/**
 * @param {RecommendationWidgetData} dyData The widget recommendation data from the DY API
 * @returns {DynamicYieldWidgetTracking} DY tracking data needed for the widget container
 */


const getDyWidgetTracking = dyData => ({
  widgetId: dyData.wId.toString(),
  feedId: dyData.fId.toString()
});
/**
 * Helper to retrieve product data from Shopify AJAX API for all DY product tiles
 * @param {Slot[]} slots Each Dynamic Yield slot respresnts one product
 * @returns {Promise<ProductTile[]>}
 */


const retrieveProductDataFromShopify = async slots => {
  /** @type {GQLProductJSON['data']} */
  const data = await getProductTileData({
    count: slots.length,
    query: getProductIdQuery(slots)
  }); // Remap product data for product tiles UI

  return data.products.edges // Temporary workaround to filter out products that are not available
  // @see DEC-5744
  .filter(edge => edge.node.isAvailable).map(edge => remapProductForProductTile({
    product: edge.node,
    slots
  }));
};
/**
 * Creates the query string used in the GraphQL query
 * @param {Slot[]} slots
 * @return {string} E.g. 'id:123 OR id:456 OR id:789'
 */


const getProductIdQuery = slots => slots.map(slot => "id:" + slot.item.group_id).join(' OR ');
/**
 * Cleans up if unable to initialize DY carousels
 * @param {object} props
 * @param {HTMLElement} props.containerEl
 * @param {Error} props.error
 */


const abandonInit = ({
  containerEl,
  error
}) => {
  containerEl.remove(); // Re-throw the error to keep the stack trace

  throw error;
};

export { ProductTile as P, initDyRecommendations as i };
